/**
 * @class ServerResult
 * @constructor
 * @returns {ServerResult}
 */
import ServerResultWinline from "./ServerResultWinline";

export default function ServerResult() {
	/** @type {Object} */
	this.data;
}

/**
 * @param {Object} data
 * @returns {undefined}
 */
ServerResult.prototype.init = function(data) {
	this.data = data;
};

/**
 * @returns {Array|undefined}
 */
ServerResult.prototype.getLineWins = function() {
	return this.data["result"]["lineWins"];
};

/**
 * @param {number} index
 * @returns {ServerResultWinline|undefined}
 */
ServerResult.prototype.getServerResultWinline = function(index) {
	if(!this.data["result"]["lineWins"] || !this.data["result"]["lineWins"][index]) {
		return;
	}

	var resultWinline = new ServerResultWinline();
	resultWinline.init(this.data["result"]["lineWins"][index]);

	return resultWinline;
};

/** @returns {Array<ServerResultWinline>|void} */
ServerResult.prototype.getServerResultWinlines = function() {

	if(!this.data["result"]["lineWins"] || !this.data["result"]["lineWins"].length) {
		return;
	}

	var winlines = [];

	for(let i = 0; i < this.data["result"]["lineWins"].length; i++) {
		winlines.push(this.getServerResultWinline(i));
	}

	return winlines;
};

/**
 * @returns {number} Index of "searching" reel
 */
ServerResult.prototype.getSearchingScatter = function() {
	return this.data["result"]["gameSpecifics"]["searching"];
};

/**
 * @param {number} index
 * @returns {ServerResult|undefined}
 */
ServerResult.prototype.getFreeSpinResult = function(index) {

	if(/*!this.getFreeSpinResults() || */typeof this.data["result"]["freeSpinResults"][index] === 'undefined') {
		return;
	}

	var fsResult = new ServerResult();
	fsResult.init(this.data["result"]["freeSpinResults"][index]);

	return fsResult;

};

/**
 * @returns {Array|undefined}
 */
ServerResult.prototype.getFreeSpinResults = function() {
	if(typeof this.data["result"]["freeSpinResults"] === 'undefined') {
		return;
	}

	return this.data["result"]["freeSpinResults"];
};

ServerResult.prototype.getReelMatrixAll = function() {
	return this.data["result"]["reelMatrix"];
};

ServerResult.prototype.getReelMatrix = function(index) {
	return this.data["result"]["reelMatrix"][index];
};

ServerResult.prototype.getGameSpecifics = function() {
	return this.data["result"]["gameSpecifics"];
};


ServerResult.prototype.getShuffleSymbols = function() {
	return this.data["result"]["gameSpecifics"]["shuffleSymbols"];
};

/** @returns {number} */
ServerResult.prototype.getTotalWin = function() {
	return this.data["result"]["totalWin"];
};

/** @returns {number|undefined} */
ServerResult.prototype.getWin = function() {

	if(typeof this.data["result"]["win"] !== 'undefined') {
		return this.data["result"]["win"];
	}
};

/**
 * Returns round total win (sumarized)
 * @returns {number}
 */
ServerResult.prototype.getLinesWinTotal = function() {
	var total = 0;
	var linesWins = this.getLineWins();

	if(linesWins) {
		for(var i = 0; i < linesWins.length; i++) {
			if(typeof linesWins[i]['win'] !== 'undefined') {
				total += linesWins[i]['win'];
			}
		}
	}

	return total;
};

/** @returns {number|undefined} */
ServerResult.prototype.getFreeSpinNumber = function() {

	if(typeof this.data["result"]["freeSpinNumber"] !== 'undefined') {
		return this.data["result"]["freeSpinNumber"];
	}
};